import { render, staticRenderFns } from "./SportCreateForm.vue?vue&type=template&id=2ede6e44&"
import script from "./SportCreateForm.vue?vue&type=script&lang=js&"
export * from "./SportCreateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports